// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"349":"2d389f31","856":"b5503735"}[chunkId] + ".js";
};